import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-between items-center mb-10 bg-white p-6 border rounded shadow-sm" }
const _hoisted_3 = { class: "text-2xl font-black" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "ml-2 text-base font-medium" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "font-bold text-lg mb-4 flex justify-between items-center" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "ml-2 text-base font-medium" }
const _hoisted_11 = { class: "block font-medium" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "block text-gray-700 mb-4"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "rounded-md bg-red-50 p-6 mb-6 text-red-700 border border-red-700" }
const _hoisted_16 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusBadge = _resolveComponent("StatusBadge")!

  return (_ctx.company && _ctx.form)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.company.name), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.form.data.name), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_StatusBadge, {
              status: _ctx.form.data.status
            }, null, 8, ["status"]),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.form.data.progress) + "% ", 1)
          ])
        ]),
        _hoisted_6,
        _hoisted_7,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionsSchema, (section) => {
          return (_openBlock(), _createElementBlock("div", {
            key: section,
            class: "flex flex-col bg-white p-6 border rounded shadow-sm mb-6"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(section.schema.title), 1),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_StatusBadge, {
                  status: section.document.data.status
                }, null, 8, ["status"]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(section.document.data.progress) + "% ", 1)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.schema.fields, (field) => {
              return (_openBlock(), _createElementBlock("div", { key: field }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(field.label) + ":", 1),
                (field.component === 'FileInput')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "block text-brand mb-4 cursor-pointer hover:underline",
                      onClick: ($event: any) => (_ctx.getDownloadUrl(field.value))
                    }, _toDisplayString(field.value), 9, _hoisted_12))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(field.value), 1))
              ]))
            }), 128))
          ]))
        }), 128))
      ]))
    : (_ctx.errors.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                key: error,
                class: "text-red-700"
              }, _toDisplayString(error), 1))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, " Loading Form... "))
}